import {useSuspenseQuery} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {getMyCarDetail} from '@di-shared/api/cci/auth';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

export interface HomeTitleHeaderKrProps {
  vin: string;
}

function HomeTitleHeader({vin}: HomeTitleHeaderKrProps) {
  const {t} = useInferableTranslation();

  const {data: carDetailData} = useSuspenseQuery({
    queryKey: [getQueryKey(getMyCarDetail), vin],
    queryFn: () => getMyCarDetail(vin),
    staleTime: 5 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });

  return (
    <div className="home_heading">
      <h1 className="home_title">
        <span className="home_title_text">
          <span className="car_model_name">{carDetailData.vehicleNameView}</span>
        </span>
        <span className="home_title_logo">
          <span
            className="ic logo_driving_insight"
            role="img"
            aria-label={t('ctn_home_title_drivinginsight')}
          />
        </span>
      </h1>
    </div>
  );
}

function HomeTitleHeaderLoading() {
  return (
    <div className="home_heading">
      <strong className="home_title">
        <span
          className="home_title_text"
          style={{marginBottom: '8px'}}
        >
          <span
            className="car_model_name skeleton"
            style={{width: '128px', height: '28px'}}
          ></span>
        </span>
        <span className="home_title_text">
          <span
            className="car_model_name skeleton"
            style={{width: '190px', height: '28px'}}
          ></span>
        </span>
      </strong>
    </div>
  );
}

function HomeTitleHeaderError() {
  const {t} = useInferableTranslation();

  return (
    <div className="home_heading">
      <strong className="home_title">
        <span className="home_title_text"></span>
        <span
          className="ic logo_driving_insight"
          role="img"
          aria-label={t('ctn_home_title_drivinginsight')}
        />
      </strong>
    </div>
  );
}

HomeTitleHeader.Loading = HomeTitleHeaderLoading;
HomeTitleHeader.Error = HomeTitleHeaderError;

export default HomeTitleHeader;
